export function isWeChat() {
	const ua = navigator.userAgent.toLowerCase()
	// 微信小程序特有UA标识
	return ua.includes('miniprogram') || ua.includes('micromessenger') && ua.includes('miniprogram')
}
